export default {"src":"/_next/static/image/public/images/ic_video_mic_off.3cbf0079c2dd6642b4a410a22df37c4a.svg","height":56,"width":56};